import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Header from "../components/header/header";
import HeaderLinks from "../components/header/headerLinks";
import styles from "assets/jss/pages/home.js";
import Button from "../components/customButtons/Button";
import GridContainer from "components/grid/GridContainer.js";
import GridItem from "components/grid/GridItem.js";
import Parallax from "../components/Parallax/Parallax";
import RamaGallery from "../sections/gallery";
import classNames from "classnames";

const dashboardRoutes = [];
const useStyles = makeStyles(styles);

export default function Home(props) {
    const classes = useStyles();
    const { ...rest } = props;
    return (
        <div>
            <Header
                color="transparent"
                routes={dashboardRoutes}
                brand="Ramazaki Gallery Photo"
                rightLinks={<HeaderLinks />}
                fixed
                changeColorOnScroll={{
                    height: 400,
                    color: "white"
                }}
                {...rest}
            />
            <Parallax filter image={require("assets/img/hom2.jpg")}>
                <div className={classes.container}>
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={6}>
                            <h1 className={classes.title}>Chef d'oeuvre du Musée de Louvre.</h1>
                            <h4>
                                Photo prise pendant une agréable visite au Musée de Louvre
                                de Paris.
                            </h4>
                            <br />
                            <Button
                                color="danger"
                                size="lg"
                                href="https://www.youtube.com/watch?v=7wXwwGXUMgE"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <i className="fas fa-play" />
                                Watch video
                            </Button>
                        </GridItem>
                    </GridContainer>
                </div>
            </Parallax>
            <div className={classNames(classes.main, classes.mainRaised)}>
                <div className={classes.container}>
                    <RamaGallery/>
                </div>
            </div>
        </div>
    )
}